import React from "react";
import AccountMap from "./AccountMap";
import styles from "../../css/account/accountPickupDirectionsPane.less";
import {translate} from '../../i18n/translate.js';

export const AccountPickupDirectionsPane = (props) => (
            <div className="account-pickup-directions-container">
                {
                    props.clientViewPort.isXs?
                        <div className="account-header-title-container">
                            <div className="account-header-title">{translate("Pickup Directions")}</div>
                        </div>:undefined
                }
                <div className="account-pickup-site-instructions-container">
                    {props.pickupSite.siteHosts && props.pickupSite.siteHosts.length > 0?
                        <div className="account-pick-site-host">
                            <div className="account-pickup-site-directions-title">{translate("Site Host Contact Information")}</div>
                            <div className="account-pickup-site-directions-details">
                                <div>{props.pickupSite.siteHosts[0].firstName + " " + props.pickupSite.siteHosts[0].lastName}</div>
                                <div>{props.pickupSite.siteHosts[0].primaryPhone}</div>
                                <div>{props.pickupSite.siteHosts[0].email}</div>
                            </div>
                        </div>:<div className="account-pick-site-host-empty"/>}
                    {(props.pickupSite.instructions || props.pickupSite.instructionsLink)?
                        <div className="account-pickup-site-directions">
                            <div className="account-pickup-site-directions-title">{translate("Site Instructions")}</div>
                            <div className="account-pickup-site-directions-details">
                                {props.pickupSite.instructions ? <div>{props.pickupSite.instructions}</div> : undefined}
                                {props.pickupSite.instructionsLink ?
                                <a className="account-pickup-site-directions-more-info" href={props.pickupSite.instructionsLink}
                                   target="_blank">{translate("More Info")}</a> : undefined}
                            </div>
                        </div>:undefined}
                    {<div className="account-pickup-site-directions">
                        <div className="account-pickup-site-directions-title">{translate("Directions to Your Site")}</div>
                        <div className="account-pickup-site-directions-details">
                            {props.pickupSite.directions ? <div>{props.pickupSite.directions}</div> : undefined}
                            {props.pickupSite.directionsLink ?
                                <a className="account-pickup-site-directions-more-info" href={props.pickupSite.directionsLink}
                                   target="_blank">{translate("More Info")}</a> : undefined}
                        </div>
                    </div>}
                </div>
                <AccountMap pickupSite={props.pickupSite} errorFetching={props.errorFetching}/>
            </div>);


// WEBPACK FOOTER //
// ./src/components/account/AccountPickupDirectionsPane.js